
document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-bf-s10-gallery]').forEach(function(root){
    var main=root.querySelector('[data-s10-main-image]');
    root.querySelectorAll('[data-s10-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        if(!main)return;
        main.src=btn.dataset.s10Image||'';
        main.removeAttribute('srcset');
        main.alt=btn.dataset.s10Alt||'';
        root.querySelectorAll('[data-s10-thumb]').forEach(function(x){x.setAttribute('aria-current','false')});
        btn.setAttribute('aria-current','true');
      });
    });
  });
  document.querySelectorAll('[data-bf-s10-scroll-buy]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      var target=document.querySelector('#bf-supify-buy');
      if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'center'});}
    });
  });
  document.querySelectorAll('[data-bf-s10-mobile-add]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var form=document.querySelector('[data-bf-s10-product-form]');
      if(form){if(form.requestSubmit)form.requestSubmit();else form.submit();}
    });
  });
});
